import { backendAPI } from '../../helper/apis';

export const fetchPaymentStatus = (packagePurchaseID) => {
  return backendAPI.get(`/packpurchase/checkpayment/${packagePurchaseID}`);
}